import React, { useState, useEffect, useRef } from 'react';

import { Container } from '@material-ui/core';

import { useLocation } from 'react-router-dom';

import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const IMoneyPayTransaction = () => {
    const formRef = useRef(null);

    const location = useLocation();
    const CallBackURL = location.state.CallBackURL;
    const FormActionURL = location.state.FormActionURL;
    const CheckSum = location.state.CheckSum;
    const OrderID = location.state.OrderID;
    const MerchantID = location.state.MerchantID;
    const Amount = location.state.Amount;
    const Name = location.state.Name;
    const Email = location.state.Email;
    const ContactNumber = location.state.ContactNumber;

    const Currency = location.state.Currency;

    const initialValues = {
        CallBackURL: CallBackURL,
        CheckSum: CheckSum,
        FormActionURL: FormActionURL,
        OrderID: OrderID,
        MerchantID: MerchantID,
        Amount: Amount,
        Name: Name,
        Email: Email,
        ContactNumber: ContactNumber,
        Currency: Currency
    };

    const [FormObj, setFormObj] = useState(initialValues);

    useEffect(() => {
        formRef.current.submit();
    }, []);
    return (
        <CustomContainer>
            <form
                ref={formRef}
                id="form1"
                method="post"
                name="form1"
                action={FormObj.FormActionURL}
            >
                <input type="hidden" name="PAY_ID" value={FormObj.MerchantID} />
                <input type="hidden" name="ORDER_ID" value={FormObj.OrderID} />
                <input type="hidden" name="AMOUNT" value={FormObj.Amount} />

                <input
                    type="hidden"
                    name="CURRENCY_CODE"
                    value={FormObj.Currency}
                />

                <input type="hidden" name="CUST_NAME" value={FormObj.Name} />
                <input
                    type="hidden"
                    name="CUST_PHONE"
                    value={FormObj.ContactNumber}
                />

                <input type="hidden" name="CUST_EMAIL" value={FormObj.Email} />

                <input
                    type="hidden"
                    name="RETURN_URL"
                    value={FormObj.CallBackURL}
                />
                <input type="hidden" name="HASH" value={FormObj.CheckSum} />
                <input type="submit" value="Redirect" />
            </form>
        </CustomContainer>
    );
};
